<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card class="card">
          <div class="row">
            <div class="col-md-3">
              <a href="#" @click.prevent="refreshMatches()"
                ><em
                  class="tim-icons icon-refresh-02"
                  :class="refreshingAnimation"
                  style="font-size: 22px; margin-bottom: 10px; margin-top: 10px"
                ></em
              ></a>
              <span style="margin-left: 20px; font-size: 18px;"
                >Refreshed at {{ lastRefreshedAt }}</span
              ><br>
                <button type="button" class="btn btn-primary mb-4 float-left" @click="showAddNameModal = true; alternativeNameFormAction = 'Add'">
                  New Alternative Name
                </button>
            </div>
            <div class="col-md-5 text-center">
              <span style="font-size: 18px; text-align: center;"
                >Filter by:
                <base-input class="d-inline-block second-select  col-md-2" style="min-width: 50px;">
                  <select class="form-control my-select" id="filter" :value="filter" @change="onSelectedFilterChanged">
                    <option v-for="option in filters" :key="option" :value="option">
                      {{ option }}</option
                    >
                  </select>
                </base-input>
              </span>
            </div>
            <div class="col-md-4">
              <span v-for="item in lastSystemRun" :key="item.id">
                <span style="font-size: 14px; float:right"
                  >{{ item.name}}: {{ item.last_run_at }}</span
                ><br>
              </span>
            </div>
          </div>
          <match-table :headers="headers" :rows="rows" :category="categoryName" :filter="filter" :filter2="filter2" :bookie-base-url="bookieBaseUrl"/>
          <dashboard-section-links />
        </card>
      </div>
      <add-alternative-match-dialog :showAddNameModal="showAddNameModal" :form="alternativeNameForm" :formAction="alternativeNameFormAction" @close="showAddNameModal = false; resetForm()" />
    </div>
  </div>
</template>
<script>
import MatchTable from '@/components/MatchTable.vue'
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import formatDateTime from "../mixin/formatDateTime";
import AddAlternativeMatchDialog from '@/components/AddAlternativeMatchDialog.vue';
import DashboardSectionLinks from '@/components/DashboardSectionLinks.vue';
import createPoller from '@/utils/createPoller';

export default {
  components: {
    MatchTable,
    AddAlternativeMatchDialog,
    DashboardSectionLinks
  },
  mixins: [formatDateTime],
  data() {
    return {
      lastRefreshedAt: this.formatTime(new Date()),
      refreshingAnimation: "",
      lastSystemRun: "unknown",
      isRefreshing: false,
      filters: ["All", "Checked", "Unchecked"],
      filters2: ["All", "Covered", "Not Covered"],
      rows: [],
      headers: [
        {
          label: "ID",
          field: "id",
        },
        {
          label: "Kick Off",
          field: "kick_off",
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm",
          dateOutputFormat: "yyyy-MM-dd HH:mm"
        },
        {
          label: "Matches",
          field: "home_team",
          sortable: false
        },
        {
          label: "Added On",
          field: "created_at",
        },
        {
          label: "Updated On",
          field: "updated_at",
        },
        {
          label: "Is Checked",
          field: "is_checked",
        },
        {
          label: "Is Hidden",
          field: "is_hidden",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Searched providers",
          field: "searched_providers_list",
        },
        {
          label: 'Actions',
          field: 'actions'
        }
      ],
      showAddNameModal: false,
      alternativeNameForm: {
        bookie: '',
        match_name: '',
        alternative_name: '',
        category: '',
        has_error : false,
        error_message : '',
      },
      alternativeNameFormAction: 'Add',
    };
  },
  computed: {
    ...mapGetters(["filter", "filter2", "selectedBookie"]),
    categoryName () {
      return this.$route.name
    },
    bookieBaseUrl() {
      switch (this.selectedBookie) {
        case "Odibets":
          return "https://www.odibets.com/sportevent/";
        case "Betika":
          return "https://www.betika.com/en-ke/m/";
        case "Betlion":
          return "https://mobile.betlion.ke/Event/Event?EventId=";
        case "Flashscore":
          return "https://www.flashscore.com/match/";
        case "Soccer365":
          return "https://soccer365.me/games/";
        case "Redscores":
          return "https://redscores.com/match/";
        case "Ababet":
          return "https://www.ababet.ug/soccer/event/";
        case "1xbet":
          return "https://1xbet.co.ke/en/line/";
        default:
          return "https://www.odibets.com/sportevent/";
      }
    },
  },
  watch: {
    selectedBookie(value) {
      this.alternativeNameForm.bookie = value.toLowerCase()
      this.matchesPoller.restart();
      this.configureOptionalHeaders()
    },
    bookieBaseUrl() {
      this.matchesPoller.restart();
    },
    isRefreshing() {
      if (this.isRefreshing) {
        this.refreshingAnimation = "rotating";
      } else {
        this.refreshingAnimation = "";
      }
    },
  },
  methods: {
    ...mapActions(["setFilter", "setFilter2"]),
    onSelectedFilterChanged(event) {
      this.setFilter(event.target.value);
    },
    onSelectedFilter2Changed(event) {
      this.setFilter2(event.target.value);
    },
    getLastSystemRun() {
      return axios
        .get("/last-system-run")
        .then(response => {
          // handle success
          const data = response.data;
          this.lastSystemRun = data.map(item => {
            return {
              id: item.id,
              name: item.name,
              last_run_at: this.formatDateTime(item.last_run_at)
            };
          });
          this.isRefreshing = false;
        })
        .catch(error => {
          // handle error
          console.log(error);
          this.isRefreshing = false;
        });
    },
    getMatches() {
      // Make a request for rows
      return axios
        .get(
          `/matches/${
            this.categoryName
          }?bookie=${this.selectedBookie.toLowerCase()}&filter=all`
        )
        .then(response => {
          // handle success
          this.rows = response.data;
          this.lastRefreshedAt = this.formatTime(new Date());
          this.isRefreshing = false;
        })
        .catch(error => {
          // handle error
          console.log(error);
          this.isRefreshing = false;
        });
    },
    resetForm() {
      this.alternativeNameForm.match_name = ''
      this.alternativeNameForm.alternative_name = ''
      this.alternativeNameForm.has_error = false
      this.alternativeNameForm.error_message = ''
    },
    refreshMatches() {
      console.log("refreshing...");
      this.matchesPoller.restart();
    },
    configureOptionalHeaders() {
      if (this.selectedBookie !== 'Flashscore' && this.headers.length === 4) {
        this.headers.push({
          label: "Checked",
          field: "is_checked"
        })
      } else if (this.selectedBookie === 'Flashscore' && this.headers.length === 5) {
        this.headers.pop()
      }
    },
    toTitleCase(str) {
        return str.toLowerCase().split(" ").map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(" ");
    },
    replaceHyphenWithSpaces(string) {
        return string.split("-").join(" ");
    },
  },
  created() {
    this.systemRunPoller = createPoller({
      fetchFn: () => this.getLastSystemRun(),
      interval: 30000,
      immediate: true,
      onError: (error) => console.error('Error fetching last system run:', error),
    });
    this.matchesPoller = createPoller({
      fetchFn: () => {
        this.isRefreshing = true;
        return this.getMatches().finally(() => {
          this.isRefreshing = false;
        });
      },
      interval: 60000,
      immediate: true,
      onError: (error) => console.error('Error fetching matches:', error),
    });
  },
  mounted() {
    this.systemRunPoller.start();
    this.matchesPoller.start();

    this.configureOptionalHeaders();
    this.alternativeNameForm.bookie = this.selectedBookie.toLowerCase();
    this.alternativeNameForm.category = this.toTitleCase(this.replaceHyphenWithSpaces(this.categoryName));
    if (this.alternativeNameForm.category === 'Hockey') {
      this.alternativeNameForm.category = 'Ice Hockey';
    }
  },
  beforeDestroy() {
    this.systemRunPoller.destroy();
    this.matchesPoller.destroy();
  }
};
</script>

<style>
@media (min-width: 480px) {
    .second-select {
        margin-left: 85px;
    }
}
.progress-horizontal {
  display: block;
  width: 100%;
  height: 4px;
  margin: 0;
  background-color: rgba(0, 0, 0, 0.34);
  overflow: hidden;
}

.bar-horizontal {
  width: 50%;
  height: 100%;
  margin-left: 0;
  background-color: #3eaa78;

  animation-name: spinner;
  animation-duration: 2000ms;
  animation-timing-function: ease-in-out;
  animation-play-state: running;
  animation-direction: normal;
  animation-iteration-count: infinite;
}

@keyframes spinner {
  0% {
    width: 0;
  }
  50% {
    width: 100%;
    margin-left: 50%;
  }
  100% {
    width: 0;
    margin-left: 100%;
  }
}
table.vgt-table {
  font-family: Poppins, sans-serif;
  font-size: 0.875rem !important;
}
</style>

<style scoped>
.my-select {
  background-color: #27293d;
  color: #ffffff;
  padding: 6px 20px;
  min-width: 150px;
}
.bootstrap-select.btn-group .dropdown-menu > li > a {
  color: green;
}
.rotating {
  -webkit-animation: rotation 2s infinite linear;
  animation: rotation 2s infinite linear;
}
@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
</style>
